import { QueryKey } from '@/composable/services/utilities/query-key'
import type { FeatureFlag } from '@/model/feature-flag'
import { featureFlagsRepository } from '@/repositories/feature-flags-repository'
import { useQuery, useQueryClient } from '@tanstack/vue-query'
import dayjs from 'dayjs'

export const useFeatureFlags = () => {
  const queryClient = useQueryClient()

  const { data: featureFlags } = useQuery({
    queryKey: [QueryKey.FeatureFlags],
    queryFn: featureFlagsRepository.all,
    staleTime: dayjs.duration(2, 'minutes').asMilliseconds(),
    refetchInterval: dayjs.duration(5, 'minutes').asMilliseconds(),
  })

  return {
    isFeatureActive(featureFlag: FeatureFlag) {
      return featureFlags.value?.includes(featureFlag) || false
    },
    initFeatureFlags() {
      return queryClient.ensureQueryData({ queryKey: [QueryKey.FeatureFlags] })
    },
  }
}
